import Vue from 'vue'
import Vuex from 'vuex'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import getters from '@/store/getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'en',
    events: false,
    content: false,
    cats: {
      'talk': 'conversation',
      'workshop': 'atelier',
      'reading_group': 'groupe de lecture',
      'screening': 'projection',
      'performance': 'performance'
    },
    searchTerm: null,
    searchResults: null
  },
  actions,
  mutations,
  getters
})
